import {createPortal} from 'react-dom';
import {CallLayer} from '../components/CallLayer';
import {VideoReliefToast} from './VideoReliefToast';

export const VideoReliefToasts = () =>
    createPortal(
        <CallLayer>
            <div className="phq-call-ui pointer-events-none fixed left-1/2 top-3 z-[70] flex w-[min(640px,calc(100vw-32px))] -translate-x-1/2 flex-col items-center gap-2">
                <VideoReliefToast/>
            </div>
        </CallLayer>,
        document.body,
    );
